import React, { useState, useEffect } from "react";
import {
  makeStyles,
  Typography,
  Paper,
  Grid,
  Backdrop,
  lighten,
  Button,
  ButtonGroup,
  useTheme,
  CircularProgress,
  Tooltip
} from "@material-ui/core";

import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import UpdateIcon from "@material-ui/icons/Update";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";

import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import TableHead from "@material-ui/core/TableHead";

import { useDispatch, useSelector } from "react-redux";
import { TablePaginationActions } from "../../utils/TablePaginationAction";
import Search from "../../utils/Search";
import { getItems } from "../../actions/inventoryAction";
import CreateItemModal from "../Modals/Item/CreateItemModal";
import Feedback from "../../utils/Feedback";
import EditItemModal from "../Modals/Item/EditItemModal";
import DeleteItemModal from "../Modals/Item/DeleteItemModal";
import ItemQuantModal from "../Modals/Item/ItemQuantModal"

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),

    // width: "100%",
    overflow: "hidden",
  },
  title: {
    color: lighten(theme.palette.common.black, 0.75),
    display: "block",
    fontSize: 15,
    fontWeight: 900,
  },
  textField: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  paper: {
    padding: theme.spacing(3),
  },

  action: {
    marginBottom: 30,
  },
  btn: {
    marginTop: 30,
    marginBottom: 30,
  },
  btn2: {
    marginBottom: 30,
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  table: {
    minWidth: 350,
  },
  chip: {
    paddingLeft: 8,
    paddingRight: 8,
    fontSize: "0.8rem",
  },
  green: {
    color: "#4caf50",
    fontWeight: 500
    },  
  red: {
    color: "#ef5350",
    fontWeight: 500,
    },
  marginBottom: {
    marginBottom: 30,
  },
  divider2: {
    height: 28,
    margin: 4,
  },
  info: {
    padding: theme.spacing(4),
    marginBottom: 30,
  },
  typo: {
    lineHeight: 1,
    fontWeight: 900,
  },
  avatar: {
    margin: "auto",
    width: theme.spacing(7),
    height: theme.spacing(7),
    marginBottom: 30,
  },
  link: {
    color: theme.palette.type === "light" ? "#333" : "#fff",
  },

}));

const Item = () => {
  const classes = useStyles();
  const theme = useTheme();

  const dispatch = useDispatch();

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [search, setSearch] = useState("");
  const [openCreate, setOpenCreate] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  
  const [openAllQuant, setOpenAllQuant] = useState(false);
  const [getId, setGetId] = useState("");

  const [feed, setFeed] = React.useState({
    loading: false,
    open: false,
    message: "",
    success: false,
  });

  const { loading, error, items } = useSelector((state) => state.inventory);
  const { profile } = useSelector((state) => state.users)

  useEffect(() => {
    dispatch(getItems());
  }, [dispatch]);

  useEffect(() => {
    const abortController = new AbortController();
    if (error && error !== null) {
      setFeed((prev) => ({
        loading: false,
        open: true,
        message: error,
        success: false,
      }));
    }
    return () => {
      abortController.abort();
    };
  }, [error]);

  const updateSearch = (e) => {
    setSearch(e.target.value.substr(0, 20));
  };

  const ResetSearch = (e) => {
    e.preventDefault();
    setSearch("");
  };

  const handleOpenCreate = () => {
    setOpenCreate(true);
  };

  const handleCloseCreate = () => {
    setOpenCreate(false);
  };

  const handleOpenEdit = (id) => {
    setGetId(id);
    setOpenEdit(true);
  };

  const handleCloseEdit = () => {
    setOpenEdit(false);
  };

  const handleOpenDelete = (id) => {
    setGetId(id);
    setOpenDelete(true);
  };

  const handleCloseDelete = () => {
    setOpenDelete(false);
  };

  const handleOpenAllQuant = (id) => {
    setGetId(id);
    setOpenAllQuant(true);
  };

  const handleCloseAllQuant = () => {
    setOpenAllQuant(false);
  };

  let filteredRows = () =>
    items === undefined
      ? []
      : items.filter((row) => {
          if (search !== "") {
            return (
              row.name.toLowerCase().indexOf(search.toLowerCase()) !== -1 ||
              row.category.toLowerCase().indexOf(search.toLowerCase()) !== -1 ||
              row.thickness.toLowerCase().indexOf(search.toLowerCase()) !== -1
            );
          } else {
            return row;
          }
        });

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 20));
    setPage(0);
  };

  const handleCloseFeed = () => {
    setFeed((prevState) => ({ ...prevState, open: false }));
  };

  const emptyRows =
    rowsPerPage - Math.min(rowsPerPage, Array(50) - page * rowsPerPage);

    let isAdmin = profile
    ? (profile && profile.role && 
        ((profile.role.map((role) => role.name).includes("admin") || profile.role.map((role) => role.name).includes("inventory_admin")))
    )
    : false;

  return (
    <div className={classes.root}>
      <ItemQuantModal {...{ openAllQuant, handleCloseAllQuant, id: getId }} />
      <CreateItemModal {...{ openCreate, handleCloseCreate }} />
      <EditItemModal {...{ openEdit, handleCloseEdit, id: getId }} />
      <DeleteItemModal {...{ openDelete, handleCloseDelete, id: getId }} />

      {feed.success === false && (
        <Feedback
          handleCloseFeed={handleCloseFeed}
          open={feed.open}
          severity="error"
          message={feed.message}
        />
      )}
      <Typography className={classes.title} variant="overline">
        Items
      </Typography>
      <Grid container alignItems="center" spacing={3}>
        <Grid item>
          {isAdmin && (
            <Button
              color="primary"
              variant="contained"
              onClick={handleOpenCreate}
              className={classes.btn2}
            >
              Create
            </Button>
          )}
        </Grid>
        <Grid item>
          <Search
            updateSearch={updateSearch}
            placeholder="Search..."
            search={search}
            ResetSearch={ResetSearch}
          />
        </Grid>
      </Grid>
     
      <Paper>
        <TableContainer>
          <Table className={classes.table} aria-label="custom pagination table">
            <TableHead>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>Category</TableCell>
                <TableCell>Dimension</TableCell>
                <TableCell>Thickness</TableCell>
                <TableCell>Cost</TableCell>
                <TableCell>Quantity</TableCell>
                <TableCell>Unit of Measure</TableCell>
                <TableCell>Value</TableCell>
                {isAdmin && <TableCell>Actions</TableCell>}
              </TableRow>
            </TableHead>
            <TableBody>
              {(rowsPerPage > 0
                ? filteredRows().slice(
                    page * rowsPerPage,
                    page * rowsPerPage + rowsPerPage
                  )
                : filteredRows()
              ).map((row, i) => {
                return (
                  <TableRow hover key={row._id}>
                    <TableCell component="th" scope="row">
                        {row.name}  
                    </TableCell>
                    <TableCell component="th" scope="row">
                        {row.category?.name}  
                    </TableCell>
                    <TableCell component="th" scope="row">
                        {row.dimension}  
                    </TableCell>
                    <TableCell component="th" scope="row">
                        {row.thickness}  
                    </TableCell>
                    
                    <TableCell component="th" scope="row">
                        {row.cost}  
                    </TableCell>

                    <TableCell component="th" scope="row">
                      {row.quantity > 0? (
                        <Typography variant="body2" className={classes.green}>
                            {row.quantity}
                        </Typography>
                      ):
                      row.quantity < 0? (
                        <Typography variant="body2" className={classes.red}>
                            {row.quantity}
                        </Typography>
                        
                      ):
                        <Typography variant="body2">
                            {row.quantity}
                        </Typography>
                      }
                    </TableCell>

                    <TableCell component="th" scope="row">
                      {row.uom?.name}
                    </TableCell>

                    <TableCell component="th" scope="row">
                        {row.value > 0? (
                            <Typography variant="body2" className={classes.green}>
                                {row.value}
                            </Typography>
                        ):
                        row.value < 0? (
                            <Typography variant="body2" className={classes.red}>
                                {row.value}
                            </Typography>
                        ):
                            row.value
                        }
                    </TableCell>
                    
                    {isAdmin && (
                      <TableCell>

                        <ButtonGroup variant="contained">
                            <Tooltip title="Update Quantity">
                                <Button
                                    color="default"
                                    onClick={() => handleOpenAllQuant(row._id)}
                                >
                                    <UpdateIcon />
                                </Button>
                            </Tooltip>
                            <Tooltip title="Edit Item">
                                <Button
                                    color="primary"
                                    onClick={() => handleOpenEdit(row._id)}
                                >
                                    <EditIcon />
                                </Button>
                            </Tooltip>
                            <Tooltip title="Delete Item">
                                <Button
                                    color="secondary"
                                    onClick={() => handleOpenDelete(row._id)}
                                >
                                    <DeleteIcon />
                                </Button>
                          </Tooltip>
                        </ButtonGroup>
                      </TableCell>
                    )}
                  </TableRow>
                );
              })}

              {emptyRows > 0 && (
                <TableRow style={{ height: 53 * emptyRows }}>
                  <TableCell colSpan={6} />
                </TableRow>
              )}
              {filteredRows().length === 0 && (
                <TableRow hover>
                  <TableCell
                    colSpan={10}
                    align="center"
                    style={{
                      fontWeight: 900,
                      color: "#616161",
                      textAlign: "center",
                    }}
                    component="th"
                    scope="row"
                  >
                    No Records To Display
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          component="div"
          rowsPerPageOptions={[10, 25, 50, { label: "All", value: -1 }]}
          colSpan={3}
          count={filteredRows().length}
          rowsPerPage={rowsPerPage}
          page={page}
          SelectProps={{
            inputProps: { "aria-label": "rows per page" },
            native: true,
          }}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          ActionsComponent={TablePaginationActions}
        />
      </Paper>
      <Backdrop className={classes.backdrop} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
};

export default Item;